module.exports = __webpack_public_path__ + "img/top_reference.6077e56a.jpg";